'use strict';
// TODO: Remove from `core-js@4`
require('../modules/es.set.symmetric-difference.v2');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/esnext.set.symmetric-difference.v2.js
// module id = 1513
// module chunks = 0